import React, { useEffect, useState } from "react";
import "../../views/dashboard/Dashboard.scss";
import {
  FiPlay,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../config/";
import { connect } from "react-redux";
import Mycoursedetails from "../Mycoursedetails/Mycoursedetails";

const PlaylistCard = (props) => {
  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    setOpen(false);
  }
  return (
    <div className="col">
      <div className="card h-100 shadow-sm ">
        <img
          src={`${BASE_URL}uploads/${props.item.banner}`}
          className="card-img-top"
          alt="..."
        />
        <div className="card-body">
          {/* <Link to={props?.removeButton ? (setOpen(true)) :`/course-detail/${props.item._id}`}           className="play"> */}
            <button
            style={{border: "none"}}
            className="play"
            onClick={()=> {
              props?.removeButton ? (setOpen(true)) : props.history.push(`/course-detail/${props.item._id}`)
            }}
            >
              <FiPlay />
            </button>
          {/* </Link> */}
          {
            open && (
              // console.log("----", props?.sessionId)
              <Mycoursedetails item={props} open={open} onCloseModal={onCloseModal} />
            )
          }
          <h5 className="card-title h2 font-weight-bold ">
            {props.item.title}
          </h5>
          <div className="h3 font-weight-bold text-success mt-2 mb-3">
            $ {props.item.price}
          </div>
          <p className="card-text text-muted font-weight-light h5 ">
            {props.item.description}
          </p>
        </div>
        {
          !props?.removeButton && 
          (
            <div className="card-footer bg-white ">
              <div className="h5 font-weight-light footer-text">
                4 Lectures | {props.item.duration} hr | <Link to={props.item.created_by._id === props.profile._id ? `/profile/` : `/view-profile/${props.item.created_by._id}`}>{props.item.created_by.name}</Link>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  profile: state.profile.profile,
});

export default connect(mapStateToProps, {
})(PlaylistCard);